<template>
  <b-container>
    <b-form>
      <b-row>
        <b-col lg="6">
          <ElementTextForm
            id="title"
            title="タイトル"
            :vModel="formdata.title"
            description="必須の項目です。"
            placeholder="お知らせのタイトル"
            :required="true"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementTextArea
            id="body"
            title="内容"
            :rows="8"
            :required="true"
            :vModel="formdata.body"
            placeholder="お知らせの内容"
            @changed="formChanged"
          ></ElementTextArea>

          <ElementTextForm
            id="reply_option_1"
            title="選択肢1"
            :vModel="formdata.reply_option_1"
            placeholder="選択肢1"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementTextForm
            id="reply_option_2"
            title="選択肢2"
            :vModel="formdata.reply_option_2"
            placeholder="選択肢2"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementTextForm
            id="reply_option_3"
            title="選択肢3"
            :vModel="formdata.reply_option_3"
            placeholder="選択肢3"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementTextForm
            id="reply_option_4"
            title="選択肢4"
            :vModel="formdata.reply_option_4"
            placeholder="選択肢4"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementTextForm
            id="reply_option_5"
            title="選択肢5"
            :vModel="formdata.reply_option_5"
            placeholder="選択肢5"
            @changed="formChanged"
          ></ElementTextForm>

          <ElementDatePicker
            class="mb-0"
            title="公開開始"
            id="started_at"
            :required="true"
            :state="isDateValid"
            :vModel="formdata.started_at"
            @changed="formChanged"
          ></ElementDatePicker>
          <ElementDatePicker
            title="公開終了"
            id="ended_at"
            :state="isDateValid"
            :vModel="formdata.ended_at"
            placeholder="無期限"
            @changed="formChanged"
          >
            <span v-if="!isDateValid" class="text-danger">{{ this.errors.invalidDate }}</span>
          </ElementDatePicker>

          <ElementSelectForm
            id="is_draft"
            title="公開設定"
            :vModel="formdata.is_draft"
            :options="publicationStatus"
            :required="true"
            @changed="formChanged"
          ></ElementSelectForm>
        </b-col>

        <b-col>
          <UsersSelectForm
            title="お知らせの送信先（必須）"
            :selectedUserList="formdata.to_user_ids"
            :isCheckBox="true"
            @userSelected="userSelected"
          >
            <input type="hidden" id="to_user_ids" v-model="formdata.to_user_ids" />

            <span class="text-danger" v-if="!userNum">{{ this.errors.NoUserIdSelected }}</span>
            <span v-else>計： {{ userNum }}件</span>
            <br />
          </UsersSelectForm>
        </b-col>
      </b-row>

      <b-row>
        <b-col align="right">
          <b-button inline @click="cancel()" class="mr-2">キャンセル</b-button>
          <b-button inline type="button" @click="saveAnnouncement()" variant="default">保存</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import dayjs from 'dayjs'
import api from '@/api'
import baseJs from '@/transformer/base'
import constList from '@/store/modules/ConstList'

import ElementDatePicker from '@/components/presentationals/ElementDatePicker.vue'
import ElementTextForm from '@/components/presentationals/ElementTextForm.vue'
import ElementTextArea from '@/components/presentationals/ElementTextArea.vue'
import ElementSelectForm from '@/components/presentationals/ElementSelectForm.vue'
import UsersSelectForm from '@/components/UsersSelectForm.vue'

export default {
  name: 'AnnouncementEdit',
  components: {
    ElementTextForm,
    ElementTextArea,
    ElementSelectForm,
    ElementDatePicker,
    UsersSelectForm
  },
  props: {
    announcement: Object
  },
  computed: {
    isDateValid() {
      if (this.formdata.started_at) {
        const startDate = dayjs(this.formdata.started_at)
        if (this.formdata.ended_at) {
          return startDate.isBefore(dayjs(this.formdata.ended_at)) || startDate.isSame(dayjs(this.formdata.ended_at))
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  data() {
    return {
      formdata: this.announcement,
      userNum: this.announcement.to_user_ids.length,
      addedFiles: [],
      errors: {
        invalidDate: '返信期限が公開開始日より前です。',
        NoUserIdSelected: '送信先を指定してください。'
      },
      publicationStatus: baseJs.getSelectionsByObject(constList.stateList)
    }
  },
  methods: {
    async saveAnnouncement() {
      const errorMessages = []
      if (!this.userNum) {
        errorMessages.push('お知らせの送信先を設定してください')
      }
      if (!this.isDateValid) {
        errorMessages.push('公開期間が不正です')
      }

      if (errorMessages.length) {
        this.$root.$bvToast.toast(errorMessages.join('\n'), {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          toastClass: 'pre-wrap',
          autoHideDelay: 3000
        })
        return
      }

      try {
        await api.announcement.save(this.formdata)
        let customMessage = 'お知らせ「' + this.formdata.title + '」を'
        if (this.formdata.announcement_id) {
          customMessage += '更新しました。'
        } else {
          customMessage += '追加しました。'
        }
        this.$root.$bvToast.toast(customMessage, {
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })
        this.closeModal()
        this.$emit('update')
      } catch (err) {
        const apiStatus = baseJs.getErrorStatus(err)
        const errorMessages = []
        for (const key in apiStatus.errors) {
          errorMessages.push(`・${apiStatus.errors[key]}`)
        }
        if (!errorMessages.length) {
          if (apiStatus.customMessage) {
            errorMessages.push(`・${apiStatus.customMessage}`)
          }
        }
        this.$root.$bvToast.toast(errorMessages.join('\n'), {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          toastClass: 'pre-wrap',
          noAutoHide: true
        })
      }
    },
    cancel() {
      this.closeModal(false)
    },
    closeModal(edited = true) {
      this.$emit('closeModal', edited)
    },
    formChanged(data) {
      this.formdata[data.id] = data.value
    },
    userSelected(e) {
      this.userNum = e.length
      this.formdata.to_user_ids = e
    }
  }
}
</script>
